<template>
  <button
    class="base-button"
    :class="{
      'primary': type === 'primary',
      'secondary': type === 'secondary',
      dark
    }"
    @click="$emit(emitMessage)"
  >
    <icon
      v-if="iconName"
      class="button-icon"
      :class="{
        'rotate-icon': rotateIcon,
      }"
      :name="iconName"
      :variant="iconVariant"
    />
    <span :class="{'all-upper-case': upperCase}">
      {{ text }}
    </span>
  </button>
</template>

<script>
import Icon from '@/components/singletons/icon.vue';

export default {
  components: { Icon },
  props: {
    text: {
      type: String,
      default: '',
    },
    upperCase: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    dark: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: '',
    },
    rotateIcon: {
      type: Boolean,
      default: false,
    },
    iconVariant: {
      type: String,
      default: '',
    },
    emitMessage: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.all-upper-case {
  text-transform: uppercase;
}

.base-button {
  align-items: center;
  gap: rem-calc(8);
  background-color: #ffffff;
  border-radius: rem-calc(21);
  border: 2px solid transparent;
  display: flex;
  height: 2rem;
  margin-left: 1rem;
  padding: rem-calc(8) 1rem;

  span {
    font-size: rem-calc(14);
    font-weight: $bold;
  }

  .button-icon {
    border-radius: 50%;
    border: 2px solid #001c74;
    box-sizing: border-box;
    padding: rem-calc(2);
    height: rem-calc(16);
    width: rem-calc(16);

    &.rotate-icon {
      transform: rotate(45deg);
    }
  }

  &.primary {
    color: #001c74;

    &.dark {
      background-color: #001c74;
      color: #ffffff;

      .button-icon {
        border-color: #ffffff;
      }
    }
  }

  &.secondary {
    border-color: #ffffff;
    color: #009FB8;

    &.dark {
      border-color: #009FB8;
    }
  }
}
</style>
